// This file is auto-generated by @hey-api/openapi-ts

import { createClient, createConfig, type Options } from '@hey-api/client-axios';
import type {
  GetCallV1CallsCallIdGetData,
  GetCallV1CallsCallIdGetError,
  GetCallV1CallsCallIdGetResponse,
  ReportCallStatusV1CallsCallIdStatusPostData,
  ReportCallStatusV1CallsCallIdStatusPostError,
  ReportCallStatusV1CallsCallIdStatusPostResponse,
  StartCallV1CallsPostData,
  StartCallV1CallsPostError,
  StartCallV1CallsPostResponse
} from './types.gen';

export const client = createClient(createConfig());

export class CallsService {
  /**
   * Start Call
   */
  public static startCallV1CallsPost<ThrowOnError extends boolean = false>(
    options: Options<StartCallV1CallsPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      StartCallV1CallsPostResponse,
      StartCallV1CallsPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/calls/'
    });
  }

  /**
   * Get Call
   */
  public static getCallV1CallsCallIdGet<ThrowOnError extends boolean = false>(
    options: Options<GetCallV1CallsCallIdGetData, ThrowOnError>
  ) {
    return (options?.client ?? client).get<
      GetCallV1CallsCallIdGetResponse,
      GetCallV1CallsCallIdGetError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/calls/{call_id}'
    });
  }

  /**
   * Report Call Status
   * Internal callback used by the delivery-agent worker process (not public).
   */
  public static reportCallStatusV1CallsCallIdStatusPost<ThrowOnError extends boolean = false>(
    options: Options<ReportCallStatusV1CallsCallIdStatusPostData, ThrowOnError>
  ) {
    return (options?.client ?? client).post<
      ReportCallStatusV1CallsCallIdStatusPostResponse,
      ReportCallStatusV1CallsCallIdStatusPostError,
      ThrowOnError
    >({
      ...options,
      url: '/v1/calls/{call_id}/status'
    });
  }
}
